import React from 'react';
import { Mail, Phone, ExternalLink } from 'react-feather';
import { Row, Col } from 'reactstrap';

interface IBlogPost {
  title: string;
  author: string;
  date: string;
  url: string;
}

interface IFooterSectionProps {
  posts: IBlogPost[];
  onViewAll?: () => void;
}

const FooterSection: React.FC<IFooterSectionProps> = ({ posts, onViewAll }) => {
  return (
    <div className="kh-footer">
      <Row>
        <Col xs={12} lg={6} className="kh-footer__col">
          <div className="kh-footer__section">
            <h3 className="kh-footer__title">Need more help?</h3>
            <p className="kh-footer__description">
              If you have questions or need assistance, our team is here to help.
            </p>
            <div className="kh-footer__contact-methods">
              <div className="kh-footer__contact-item">
                <span className="kh-footer__contact-label">Email:</span>
                <a href="mailto:hello@journeyfoods.com" className="kh-footer__contact-link">
                  hello@journeyfoods.com
                </a>
              </div>
              <div className="kh-footer__contact-item">
                <span className="kh-footer__contact-label">Sales:</span>
                <a href="mailto:sales@journeyfoods.com" className="kh-footer__contact-link">
                  sales@journeyfoods.com
                </a>
              </div>
              <div className="kh-footer__contact-item">
                <span className="kh-footer__contact-label">Phone:</span>
                <a href="tel:+18478599833" className="kh-footer__contact-link">
                  (847) 859-9833
                </a>
              </div>
            </div>
          </div>
        </Col>
        <Col xs={12} lg={6} className="kh-footer__col">
          <div className="kh-footer__section kh-footer__section--blog">
            <div className="kh-footer__blog-header">
              <h3 className="kh-footer__title">Latest from the Blog</h3>
              {onViewAll && (
                <button className="kh-footer__view-all" onClick={onViewAll}>
                  View all <ExternalLink size={16} />
                </button>
              )}
            </div>
            <div className="kh-footer__blog-list">
              {posts.map((post, index) => (
                <a 
                  key={index} 
                  href={post.url} 
                  className="kh-footer__blog-item" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <h4 className="kh-footer__blog-title">{post.title}</h4>
                  <p className="kh-footer__blog-meta">
                    {post.author} • {post.date}
                  </p>
                </a>
              ))}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default FooterSection;
